
    document.addEventListener('DOMContentLoaded', function () {
      const variantId = '45615842033885';

      let targetNode = document.querySelector("[data-cart-bottom]");

      let config = { childList: true, subtree: true };

      let callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === "childList") {
            let giftNoteCheckbox = document.querySelector(
              'input#checkbox_giftwrap[type="checkbox"]'
            );

            if (giftNoteCheckbox) {
              fetchVariantPrice()
                .then(price => {
                  updatePriceOnPage(price);
                })
                .catch(error => {
                  console.error(error);
                });

              observer.disconnect();
            }
          }
        }
      };

      let observer = new MutationObserver(callback);

      if (targetNode) {
        observer.observe(targetNode, config);
      }

      function fetchVariantPrice() {
        return new Promise((resolve, reject) => {
          fetch(`/variants/${variantId}.js`)
            .then(response => {
              if (!response.ok) {
                reject('Error fetching variant details');
              }
              return response.json();
            })
            .then(variant => {
              const priceInCents = variant.price;
              const priceInDollars = (priceInCents / 100).toFixed(2);
              resolve(priceInDollars);
            })
            .catch(error => {
              reject(error);
            });
        });
      }

      function updatePriceOnPage(price) {
        const priceElement = document.getElementById('proxy-product-price');
        priceElement.innerHTML = `($${price})`;
        priceElement.classList.remove('btn');
      }
    });